import React,{useState} from 'react';
import { Modal,Form, Button, Alert } from 'react-bootstrap';

function DateOfVisit (props){
    const [disabled,setDisabled] = React.useState(true)
    const [visitNo, setVisitNo] = useState(props.defaultVisitNo || "")

    const existingNums = props.existingVisitNos || []
    const parsedVisitNo = parseInt(visitNo)
    const hasConflict = !isNaN(parsedVisitNo) && existingNums.includes(parsedVisitNo)
    const conflictResolved = props.resolvedForVisitNo !== null && props.resolvedForVisitNo !== undefined && props.resolvedForVisitNo === parsedVisitNo
    const blockSubmit = hasConflict && !conflictResolved

    const handleHide = ()=>{
        setDisabled(true)
        props.handleDatePopup("hide")
    }
    const enableButton = (event) =>{
        setDisabled(false)
        props.onChange(event)
    }
    const handleVisitNoChange = (event) => {
        const val = event.target.value
        setVisitNo(val)
        if (props.onVisitNoChange) props.onVisitNoChange(val)
    }

    return(
        <Modal show={props.show} onHide={handleHide}>
            <Modal.Header closeButton>Date of Visit</Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="visitNo" className="mb-3">
                        <Form.Label>Visit number</Form.Label>
                        <Form.Control type="number" min="1" value={visitNo} onChange={handleVisitNoChange} isInvalid={hasConflict && !conflictResolved} isValid={hasConflict && conflictResolved} />
                    </Form.Group>
                    {hasConflict && !conflictResolved &&
                        <Alert variant="warning" className="mb-3 d-flex align-items-center justify-content-between">
                            <span>Visit {parsedVisitNo} already exists. Fix the visit order first.</span>
                            <Button size="sm" variant="warning" className="ms-3 text-nowrap" onClick={() => props.onConflict && props.onConflict(parsedVisitNo)}>
                                Fix Visit Order
                            </Button>
                        </Alert>
                    }
                    {hasConflict && conflictResolved &&
                        <Alert variant="success" className="mb-3">Visit order updated — you can now submit.</Alert>
                    }
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>Please select date of visit</Form.Label>
                        <Form.Control type="date" name={"date"} placeholder="Enter date of visit" onChange={enableButton} />
                    </Form.Group>
                </Form>

            </Modal.Body>
            <Modal.Footer>
                <Button variant='success' disabled={disabled || props.disableSubmit || blockSubmit} onClick={props.handleSubmit}> Submit</Button>
            </Modal.Footer>
        </Modal>
    )


}
DateOfVisit.defaultProps = {
    show:false
}

export default DateOfVisit;
